import styled, { FlattenInterpolation, ThemeProps } from 'styled-components';
import { ReactNode, useState } from 'react';
import {
  FormInput, ModelRadioInput, UpdateType,
  useModelForm,
} from '../modelInputs';
import { Input } from './Input';
import { Flex } from '../../Flex';
import { ThemeType, useFormConfigurationContext } from '../../../..';

export const RadioYesNoInputWrapper = styled(Flex)<{css?: FlattenInterpolation<ThemeProps<ThemeType>> | string}>`
  width: max-content;
  ${(props) => props.css}
`;

type RadioYesNoInputProps = {
  id?: string,
  field: string,
  label?: ReactNode,
  required?: boolean;
  touchOverride?: boolean,
  errorOverride?: string,
  hasError?: boolean,
  updateOverride?: UpdateType,
  visible?: boolean,
  isInline?: boolean,
  disabled?: boolean,
  yesLabelOverride?: string,
  noLabelOverride?: string,
  valueOverride?: boolean,
  mutateValue?: (v: boolean) => boolean,
  containerStyle?: FlattenInterpolation<ThemeProps<ThemeType>> | string,
  tooltip?: ReactNode,
}

export function RadioYesNoInput({
  id,
  field,
  label,
  touchOverride = false,
  errorOverride = '',
  hasError = false,
  updateOverride,
  required,
  visible = true,
  isInline,
  disabled = false,
  yesLabelOverride = 'Yes',
  noLabelOverride = 'No',
  valueOverride,
  mutateValue = (v: boolean) => v,
  containerStyle = '',
  tooltip = '',
}: RadioYesNoInputProps) {
  const [touched, setTouched] = useState<boolean>(false);
  const { errors, warnings } = useModelForm(field, valueOverride, errorOverride, updateOverride);
  const showError = (hasError || !!errors?.length) && touched;

  const { isDisabled } = useFormConfigurationContext(disabled);

  return (
    <FormInput visible={visible}>
      <Input
        label={label}
        id={field}
        required={required}
        errors={errors}
        warnings={warnings}
        hasError={showError}
        tooltip={tooltip}
      >
        <RadioYesNoInputWrapper css={containerStyle}>
          <ModelRadioInput
            id={`${id || field}-yes`}
            field={field}
            name={field}
            label={yesLabelOverride}
            defaultValue
            touchOverride={touchOverride}
            errorOverride={errorOverride}
            updateOverride={updateOverride}
            isInline={isInline}
            disabled={isDisabled}
            valueOverride={valueOverride}
            mutateValue={mutateValue}
            onBlur={() => setTouched(true)}
          />
          <ModelRadioInput
            id={`${id || field}-no`}
            field={field}
            name={field}
            label={noLabelOverride}
            defaultValue={false}
            touchOverride={touchOverride}
            errorOverride={errorOverride}
            updateOverride={updateOverride}
            isInline={isInline}
            disabled={isDisabled}
            valueOverride={valueOverride}
            mutateValue={mutateValue}
            onBlur={() => setTouched(true)}
          />
        </RadioYesNoInputWrapper>
      </Input>
    </FormInput>
  );
}
